import { CKCardCollapsible } from 'clearkit';

import EmptyFieldMappingFields from '../EmptyFieldMappingFields';
import FieldMappingFooter from '../FieldMappingFooter';
import FieldMappingFormFields from '../FieldMappingFormFields';
import FieldMappingHeaders from '../FieldMappingHeaders';
import FieldMappingHeader from './FieldMappingHeader';

const BetaFieldMappingForm = ({
  integration,
  objectType,
  addMapping,
  areFieldMappingsInvalid,
  isUpdating,
  setConfirmSaveDialogOpen,
  setShowInvalidFields,
  fieldMappings,
  fieldErrors,
  sortedMappings,
  handleMappingChange,
  applyChangesToAllGroupMembers,
  removeMappingGroup,
  removeMapping,
  onClickRefreshAttributes,
  showInvalidFields,
  targetAttributes,
  sourceAttributes,
  hasEnrichmentBetaUIFlag,
  setFieldMappings,
  savedFieldMappings,
  lastSavedMappings,
}) => {
  const [isOpen, setIsOpen] = useState(fieldMappings.length === 0);

  useEffect(() => {
    setIsOpen(savedFieldMappings && savedFieldMappings.length === 0);
  }, [savedFieldMappings]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <CKCardCollapsible
      className="mt-10"
      isOpen={isOpen}
      onToggle={handleToggle}>
      <CKCardCollapsible.Header>
        <FieldMappingHeader
          integration={integration}
          fieldMappings={fieldMappings}
          objectType={objectType}
        />
      </CKCardCollapsible.Header>
      <CKCardCollapsible.Body>
        {fieldMappings.length === 0 ? (
          <EmptyFieldMappingFields
            integration={integration}
            objectType={objectType}
            addMapping={addMapping}
            hasEnrichmentBetaUIFlag={hasEnrichmentBetaUIFlag}
          />
        ) : (
          <div>
            <FieldMappingHeaders hasEnrichmentBetaUIFlag />
            <FieldMappingFormFields
              fieldErrors={fieldErrors}
              sortedMappings={sortedMappings}
              handleMappingChange={handleMappingChange}
              applyChangesToAllGroupMembers={applyChangesToAllGroupMembers}
              removeMappingGroup={removeMappingGroup}
              removeMapping={removeMapping}
              addMapping={addMapping}
              objectType={objectType}
              sourceAttributes={sourceAttributes}
              targetAttributes={targetAttributes}
              integration={integration}
              showInvalidFields={showInvalidFields}
              onClickRefreshAttributes={onClickRefreshAttributes}
              hasEnrichmentBetaUIFlag={hasEnrichmentBetaUIFlag}
            />
          </div>
        )}
        <CKCardCollapsible.Footer>
          <FieldMappingFooter
            isUpdating={isUpdating}
            areFieldMappingsInvalid={areFieldMappingsInvalid}
            addMapping={addMapping}
            setShowInvalidFields={setShowInvalidFields}
            setConfirmSaveDialogOpen={setConfirmSaveDialogOpen}
            fieldMappings={fieldMappings}
            setFieldMappings={setFieldMappings}
            savedFieldMappings={savedFieldMappings}
            hasEnrichmentBetaUIFlag={hasEnrichmentBetaUIFlag}
            lastSavedMappings={lastSavedMappings}
          />
        </CKCardCollapsible.Footer>
      </CKCardCollapsible.Body>
    </CKCardCollapsible>
  );
};

export default BetaFieldMappingForm;
